export let AngularNotifierOptions: any = {
    timeOut: 4000,
    positionClass: 'toast-bottom-center',
    preventDuplicates: true,
};
